import React from 'react';
import { Combo } from 'fw/forms';
import { EmailStatusCode } from 'areas/shared/consts';
import { components } from 'react-select';
import TaggedOption from './TaggedOption';

class EmailStatusCombo extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {}
	}

	completed = () => { return this._ctrl.completed(); }
	flag = (s) => { return this._ctrl.flag(s); }

	componentDidMount() {
        var items= Object.entries(EmailStatusCode.ITEMS).map(
			([key, value]) => { 
				return { label: key, value: value };
			}
		);
					
		this.setState({items: items});
	}

	_getFieldsComboComponents = () => {
		const CustomOption = (props) => (
            <components.Option {...props}>
                <TaggedOption {...props} />
            </components.Option>
        );

        const CustomSingleValue = (props) => (
            <components.SingleValue {...props}>
                <TaggedOption {...props} />
            </components.SingleValue>
        );

        return {
            Option: CustomOption,
            SingleValue: CustomSingleValue
        }
	}
	
	render() {
		return (
			<Combo
				{...this.props}				
				components={this._getFieldsComboComponents()}
				items={this.state.items}
				searchable={false}
				ref={(c) => { this._ctrl = c }} />
		)
	}
}

export default EmailStatusCombo;

// Mark this as a form component
EmailStatusCombo.defaultProps = {
	formControl: true,
	managed: false
};


// WEBPACK FOOTER //
// ./src/areas/shared/controls/emailStatusCombo/EmailStatusCombo.js